import { render, staticRenderFns } from "./travaux-restants.vue?vue&type=template&id=9340639a&scoped=true"
import script from "./travaux-restants.vue?vue&type=script&lang=ts"
export * from "./travaux-restants.vue?vue&type=script&lang=ts"
import style0 from "./travaux-restants.vue?vue&type=style&index=0&id=9340639a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9340639a",
  null
  
)

export default component.exports